import classNames from 'classnames';
import { DetailedHTMLProps, FC, HTMLAttributes, useContext } from 'react';

import { ExternalImgPath, Image, Typography } from '@/shared/ui';

import { formatDate } from '@/helpers/dates';

import AuthContext from '@/contexts/Auth/AuthContext';

import './NewsCardMobile.scss';

interface NewsCardMobileProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  id: string;
  className?: string;
  title: string;
  image?: string;
  date: string | Date;
  onClick?: () => void;
}

export const NewsCardMobile: FC<NewsCardMobileProps> = ({ className, image, title, date, onClick, ...restProps }) => {
  const { storedLinks } = useContext(AuthContext);

  const handleClick = (): void => {
    onClick?.();
  };

  const imageSrc = image && storedLinks?.app?._baseUrl ? `${storedLinks.app._baseUrl}${image}` : undefined;
  const defaultImageSrc = '/images/news_no_photo.webp';
  const finalImageSrc = (imageSrc || defaultImageSrc) as ExternalImgPath;

  return (
    <div
      className={classNames('news-card-mobile', className)}
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleClick();
        }
      }}
      {...restProps}
    >
      <div className="news-card-mobile__image-wrapper">
        <Image src={finalImageSrc} alt={title} className="news-card-mobile__image" fallback={defaultImageSrc} />
      </div>
      <div className="news-card-mobile__content">
        <div className="news-card-mobile__date-wrapper">
          <Typography color="graphite" variant="TEXT10">
            {formatDate(date, '.', false, true)}
          </Typography>
        </div>
        <Typography className="news-card-mobile__title" variant="TEXT16">
          {title}
        </Typography>
      </div>
    </div>
  );
};
